import {
  Box,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import * as React from "react";
import config from "../../../config";
import { PTIcon, PTTypography } from "../../components/ui";
import { useLanguage } from "../../hooks";
import { translate } from "../../utils/translate";

export const FirstHeader = ({ toggleLeftBar, isMobile, ...props }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        ...(isMobile && { minWidth: "96vw" }),
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <PTIcon
          icon="grid"
          tooltip="grid"
          sx={{ width: "18px", height: "18px", cursor: "pointer" }}
          color={"#000000"}
          onClick={toggleLeftBar}
        />
        <PTTypography
          variant="body3"
          sx={{
            color: "#000000",
            cursor: "pointer",
            /*display: "webkit-box",
            overflow: "hidden",
            "-webkit-line-clamp": 2,
            "-webkit-box-orient": "vertical",*/
          }}
        >
          S’inscrire à PortNet
        </PTTypography>
        <PTTypography variant="body3" sx={{ color: "#000000" }}>
          |
        </PTTypography>
        <PTTypography
          variant="body3"
          sx={{
            color: "#000000",
            cursor: "pointer",
          }}
        >
          Guichet Unique
        </PTTypography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          alignItems: "center",
          ...(isMobile && { gap: "4px" }),
        }}
      >
        {/* <SearchInput isMobile={isMobile} /> */}
        <LanguegeSelect isMobile={isMobile} />
      </Box>
    </Box>
  );
};

const SearchInput = ({ isMobile, ...props }) => {
  const [value, setValue] = React.useState("");
  const onChangeHandler = (v) => {
    //TODO: Implement search
    setValue(v.target.value);
  };

  const searchHandler = () => {};

  return (
    <TextField
      id="outlined-basic"
      placeholder={translate("Rechercher")}
      variant="outlined"
      onChange={onChangeHandler}
      sx={{
        height: "37px",
        borderRadius: "30px",
        "& .MuiOutlinedInput-root": {
          borderRadius: "30px",
        },
        ...(isMobile && { height: "30px" }),
      }}
      InputProps={{
        style: {
          height: "37px",
        },
        endAdornment: (
          <InputAdornment position="end">
            <PTIcon
              icon="search"
              tooltip="Rechercher"
              color={"#000000"}
              onClick={searchHandler}
            />
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        style: {
          color: "#000",
          ...(isMobile && { height: "30px" }),
        },
      }}
    />
  );
};

export const LanguegeSelect = ({ isMobile, sx, ...props }) => {
  const { currentLang, changeLanguage } = useLanguage();
  const handleClick = (e) => {
    changeLanguage(e.target.value || "en");
  };
  return (
    <Select
      id="outlined-basic"
      variant="outlined"
      value={currentLang}
      onChange={handleClick}
      sx={{
        backgroundColor: "primary.main",
        color: "#FFFFFF",
        height: "37px",
        "& .MuiSelect-icon": {
          color: "#FFFFFF",
        },
        ...(isMobile && { minWidth: "70px", height: "30px" }),
        ...sx,
      }}
      MenuProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left",
        },
        PaperProps: {
          style: {
            minWidth: "100px",
          },
        },
      }}
    >
      {config.supportLanguages.map((lang) => (
        <MenuItem
          value={lang}
          key={lang}
          sx={{
            minWidth: "100px",
          }}
        >
          {lang?.toUpperCase()}
        </MenuItem>
      ))}
    </Select>
  );
};

export default FirstHeader;
